
import { defineComponent, SetupContext, PropType } from "vue";
import CommonRecipeList from "@/components/commonRecipe/CommonRecipeList.vue";
import NativeClient from "@/client/native-client";
import { CommonRecipe } from "@/types/commonRecipe";

export default defineComponent({
  name: "PantryRecommendMainView",
  components: { CommonRecipeList },
  props: {
    recipes: {
      type: Array as PropType<CommonRecipe[]>,
      default: () => []
    },
  },
  setup(props, context: SetupContext) {
    /**
     * 選択されたレシピをNativeに通知する
     */
    const selectRecipe = (id: number, type: string) => {
      context.emit("select-recipe", id, type);
    };
    const clickBack = () => {
      context.emit("click-close");
    };
    return {
      selectRecipe,
      clickBack
    };
  }
});
